export default "__VITE_ASSET__BKvOrq3K__"